import { render, staticRenderFns } from "./printerRuleFees.vue?vue&type=template&id=10d6c459&scoped=true"
import script from "./printerRuleFees.vue?vue&type=script&lang=js"
export * from "./printerRuleFees.vue?vue&type=script&lang=js"
import style0 from "./printerRuleFees.vue?vue&type=style&index=0&id=10d6c459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d6c459",
  null
  
)

export default component.exports